<button class="modal-close" (click)="close()"></button>
<h4
  class="modal-title"
  i18n="Modal|Title for giftcard settings modal @@modalGiftCardsSettingsTitle"
>
  Gift Card Settings
</h4>
<div class="modal-content">
  <!-- TODO: Translate this string -->
  <form [formGroup]="form" id="giftcardSettings" (ngSubmit)="save()">
    <ls-checkbox
      title="Enable Expiration Date"
      formControlName="expiryDateEnabled"
    ></ls-checkbox>
    <div class="c-form__item u-margin-0">
      <label
        for="giftcard-settings-month"
        i18n="Label|Label giftCards expire @@labelGiftCardsExpire"
        >Gift Cards expire after</label
      >
      <div class="c-form__amend">
        <input
          type="number"
          name="name"
          value="12"
          id="giftcard-settings-month"
          formControlName="expiryMonths"
        />
        <span
          class="c-form__amend--label"
          i18n="Label|Label for Months @@labelMonths"
          >Months</span
        >
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button
    type="button"
    name="button"
    class="o-button o-button--default"
    (click)="close()"
    i18n="Button|Cancel Button @@buttonCancel"
  >
    Cancel
  </button>
  <button
    type="submit"
    name="button"
    class="o-button o-button--success"
    form="giftcardSettings"
    i18n="Button|Save Button @@buttonSave"
  >
    Save
  </button>
</div>
